module.exports = __webpack_public_path__ + "img/icon_1222.c76dd014.svg";